export default [
  {
    value: 1,
    label: 'Segunda a Sexta Feira após as 12:00',
  },
  {
    value: 2,
    label: 'Segunda a Sexta Feira após as 13:00',
  },
  {
    value: 3,
    label: 'Segunda a Sexta Feira após as 14:00',
  },
  {
    value: 4,
    label: 'Segunda a Sexta Feira após as 15:00',
  },
  {
    value: 5,
    label: 'Segunda a Sexta Feira após as 16:00',
  },
  {
    value: 6,
    label: 'Segunda a Sexta Feira após as 17:00',
  },
  {
    value: 7,
    label: 'Segunda a Sexta Feira após as 18:00',
  },
  {
    value: 8,
    label: 'Segunda a Sexta Feira após as 19:00',
  },
  {
    value: 9,
    label: 'Segunda a Sexta Feira após as 20:00',
  },
  {
    value: 10,
    label: 'Segunda a Sexta Feira após as 21:00',
  },
];
